import React from 'react';
import { MessagePageBanner, MessagePageBannerVariant } from './MessagePageBanner.tsx';

interface ICustomerCareHeaderProps {
    adminPageUrl?: string;
    eventWiki?: string;
    sellerWiki?: string;
    phoneFee?: string;
    repName?: string;
}

export const CustomerCareHeader = ({
    adminPageUrl,
    eventWiki,
    phoneFee,
    repName,
    sellerWiki,
}: ICustomerCareHeaderProps) => (
    <div className="customer-care-header">
        {repName && repName.length > 0 &&
            <MessagePageBanner
                variant={MessagePageBannerVariant.info}
                dismissable={true}
            >
            {`This order is being recorded as being placed by a ShowClix representative (${repName}).` }
            </MessagePageBanner>
        }
        {
            (adminPageUrl || eventWiki || sellerWiki) &&
                <MessagePageBanner
                    variant={MessagePageBannerVariant.caution}
                    dismissable={true}
                >
                    {
                        sellerWiki && sellerWiki.length > 0 && <a href={sellerWiki} className="cc__link">View the seller wiki page</a>
                    }
                    {
                        eventWiki && eventWiki.length > 0 && <a href={eventWiki} className="cc__link">View the event wiki page</a>
                    }
                    {
                        adminPageUrl && adminPageUrl.length > 0 && <a href={adminPageUrl} className="cc__link">View event in admin</a>
                    }
                </MessagePageBanner>
        }
        {
            phoneFee && phoneFee.length > 0 &&
            <MessagePageBanner
                variant={MessagePageBannerVariant.success}
                dismissable={true}
            >
                {`A per ticket phone order fee of ${phoneFee} will be applied to this order`}
            </MessagePageBanner>
        }
    </div>
);